import FormInputText from '@components/forms/FormInputText';
import { Grid2, Tooltip } from '@mui/material';

export default function WrestlerEmailPhoneForm({ emailDisabled }: { emailDisabled?: boolean }) {
    return (
        <>
            <Tooltip
                title={emailDisabled ? 'Speak to an admin to edit existing user emails' : ''}
                placement="right"
            >
                <Grid2 size={{ sm: 12, md: 6 }} alignSelf={'center'}>
                    <FormInputText
                        disabled={emailDisabled}
                        name="email"
                        label="Wrestler Email (optional)"
                    />
                </Grid2>
            </Tooltip>
            <Grid2 size={{ sm: 12, md: 6 }} alignSelf={'center'}>
                <FormInputText name="phone" label="Wrestler Phone (optional)" />
            </Grid2>
        </>
    );
}
